import { Injectable } from '@angular/core';
import constantURL from 'src/app/shared/constantURL';
import { AES } from 'crypto-js';
import { BaseLoggedInPostService } from 'src/app/shared/services/base-logged-in-post.service';
import { billtrxPaymentParams } from '../../interfaces/biller-interfaces';

@Injectable({
  providedIn: 'root',
})
export class CreditCardPaymentService extends BaseLoggedInPostService {
  _path = constantURL.BillPayments.Transaction.billCreditCard;
  private _providerObject: GateLightBoxData;
  private token: string;
  private creditBody:ICreditPayReq;
  private otpPageHtml:string;
  public get providerObject() {
    return this._providerObject;
  }
  public set providerObject(value: GateLightBoxData) {
    this._providerObject = value;
  }
  public get payToken() {
    return this.creditBody;
  }
  public set otpPage(value:string){
    this.otpPageHtml = value;
  }
  public get otpPage(){
    return this.otpPageHtml;
  }
  public get encToken(){
    return this.token;
  }
  public setPayToken(payObject: ICreditPayReq,billPaymentParams: billtrxPaymentParams) {
    this.token = AES.encrypt(JSON.stringify(payObject),constantURL.SECURE_KEY).toString();
    this.setParams({encryptedData:this.token,...billPaymentParams});
  }
  public get amount () {
    return this._providerObject.amount;
  }
  public get trxRefNum () {
    return this._providerObject.trxRefNum;
  }
  public get merchant_ref_num () {
    return this._providerObject.merchant_ref_num;
  }
}
export interface ICreditPayReq {
  'expiration-month-and-year': string;
  number: string;
  'security-code': string;

}
export interface GateLightBoxData {
  amount: number;
  clientid: string;
  gateLightBox: true
  merchant_ref_num: string;
  payment_options: Array<number>;
  process_payment_api: string;
  redirect_url: string;
  trxRefNum: string;
  url: string;
  providerRefNum?: string;
  debug?: boolean;
  isInstallment?: boolean,
  installmentPlans?: string[]
}
